var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrosshairIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 18.1418C23.8686 19.0188 19.0188 23.8686 18.1418 30H22V34H18.1418C19.0188 40.1314 23.8686 44.9812 30 45.8582V42H34V45.8582C40.1314 44.9812 44.9812 40.1314 45.8582 34H42V30H45.8582C44.9812 23.8686 40.1314 19.0188 34 18.1418V22H30V18.1418ZM14.1099 30C15.0322 21.6568 21.6568 15.0322 30 14.1099V10H34V14.1099C42.3432 15.0322 48.9678 21.6568 49.8902 30H54V34H49.8902C48.9678 42.3432 42.3432 48.9678 34 49.8902V54H30V49.8902C21.6568 48.9678 15.0322 42.3432 14.1099 34H10V30H14.1099ZM38 32C38 35.3138 35.3138 38 32 38C28.6862 38 26 35.3138 26 32C26 28.6862 28.6862 26 32 26C35.3138 26 38 28.6862 38 32Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshairIcon);
export default __webpack_public_path__ + "static/media/crosshair-icon.d008f0571e16ec348137b19bbb0ebb28.svg";
export { ForwardRef as ReactComponent };